<template>
  <div>
    <figure
      data-toggle="modal"
      href="#changeAvatarModal"
      class="default-avatar"
      @click="setAvatar()"
    >
      <img :src="currentAvatar" style="object-fit: contain" alt="custom avatar" />
      <div class="overlay"><i class="fas fa-camera"></i></div>
    </figure>
    <div
      class="modal fade edit-modal"
      id="changeAvatarModal"
      tabindex="-1"
      aria-labelledby="changeAvatarModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editModal2Label">{{ title }}</h5>
            <button
              ref="closeModalUploadAvatarBtn"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div>
              <div class="d-flex justify-content-center my-4 change-avatar">
                <img class="temporary-avatar" :src="temporaryAvatar" alt="avatar" />
              </div>
              <div class="d-flex justify-content-center my-4">
                <span class="mr-2">
                  <label for="upload-avatar" class="btn btn-primary btn-sm file-upload-label mb-0"
                    ><i class="fas fa-upload"></i>Upload picture</label
                  >
                  <input
                    type="file"
                    id="upload-avatar"
                    ref="candidateAvatar"
                    name="candidateAvatar"
                    accept=".jpg,.png,.jpeg"
                    @change="switchAvatar($event)"
                  />
                </span>
                <span>
                  <button
                    v-if="photo !== 'default.png' && photo !== null"
                    @click="resetAvatar()"
                    class="btn btn-danger btn-sm mb-0"
                    type="button"
                  >
                    <i class="fas fa-upload"></i>Remove picture
                  </button>
                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button
              :disabled="!isChanged"
              @click="changeAvatar"
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
            >
              Confirm
            </button>

            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  props: { photo: String },
  data: () => ({
    cssRule: 'cover',
    title: '',
    currentAvatar: '',
    temporaryAvatar: null,
    file: null,
    isChanged: false,
    getUrl: null,
    resetUrl: null,
    uploadUrl: null,
    employerId: null,
  }),
  watch: {
    photo: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal === 'default.png' || newVal === null) {
          this.currentAvatar = 'https://jobshark.eu/img/comstream.svg';
        } else {
          this.cssRule = 'contain';
          this.currentAvatar = `https://jobshark.eu/storage/employers/logos/${newVal}`;
        }
      }
    },
  },

  methods: {
    changeAvatar(ev) {
      let formData = new FormData();
      formData.append('image', this.file);
      formData.append('candidate_id', this.$route.params.candidate_id);
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}${this.uploadUrl}`,
        data: formData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'multipart/form-data',
          'Cache-Control': 'no-cache',
        },
      }).then(() => {
        this.$emit('new');
        this.$toasted.success('Avatar changed successfully.', {
          theme: 'bubble',
          icon: 'fa-times-circle',
          position: 'bottom-right',
          duration: 8000,
        });
      });
    },

    switchAvatar(ev) {
      let maxSize = 2 * 1024 * 1024;
      if (ev.target.files[0].size <= maxSize) {
        this.file = ev.target.files[0];
        this.temporaryAvatar = URL.createObjectURL(this.file);
        this.isChanged = true;
      } else {
        this.$toasted.error('The file size exceeds the limit of 2MB.', {
          theme: 'bubble',
          icon: 'fa-unlock-alt',
          position: 'bottom-right',
          duration: 5000,
        });
      }
    },
    setAvatar() {
      this.temporaryAvatar = this.currentAvatar;
    },
    resetAvatar() {
      axios
        .delete(`${process.env.VUE_APP_API_URL}${this.resetUrl}`, {
          headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            Authorization: `Bearer ${localStorage.getItem(
              `${process.env.VUE_APP_TOKEN_PREFIX}token`,
            )}`,
          },
        })
        .then(() => {
          this.$emit('new');
          this.$refs.closeModalUploadAvatarBtn.click();
          this.$toasted.error('Avatar set to default.', {
            theme: 'bubble',
            icon: 'fa-times-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },
  },
  mounted() {
    this.title = 'Change your logo type';
    this.uploadUrl = '/manager/uploadavatar';
    this.resetUrl = `/manager/deleteavatar`;
  },
};
</script>
<style lang="scss" scoped>
.default-avatar {
  position: relative;
  width: 74px;
  height: 74px;
  margin: 0 12px 0 15px;
  flex-shrink: 0;
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none !important;
  }
  .overlay {
    cursor: pointer;
    position: absolute;
    display: flex;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    font-size: 21px;
    background: rgba(0, 0, 0, 0.4);
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.125);
    opacity: 0;
    -webkit-transition: all 200ms ease;
    -moz-transition: all 200ms ease;
    -ms-transition: all 200ms ease;
    -o-transition: all 200ms ease;
    transition: all 200ms ease;
  }
  &:hover {
    .overlay {
      opacity: 1;
    }
  }
}
.temporary-avatar {
  width: 160px;
  height: 160px;
  object-fit: contain;
}
</style>
